import { render, staticRenderFns } from "./VaChart.demo.vue?vue&type=template&id=0ed4e7f8&"
import script from "./VaChart.demo.vue?vue&type=script&lang=js&"
export * from "./VaChart.demo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports